export type EntityType =
	| 'Customer'
	| 'RoundPoint'
	| 'Player'
	| 'Team'
	| 'Game'
	| 'Event'
	| 'Room'
	| 'GamePoint';

export const enum EntityTypeEnum {
	Customer = 'Customer',
	RoundPoint = 'RoundPoint',
	Player = 'Player',
	Team = 'Team',
	Game = 'Game',
	Event = 'Event',
	Room = 'Room',
	GamePoint = 'GamePoint'
}

export interface EntityTimestamps {
	id: string;
	created_at: Date;
	updated_at: Date;
}

export class IDTimestampManager {
	private _generateUniqueId(entityType: EntityType): string {
		let randomId: string;

		if (crypto.randomUUID) {
			randomId = crypto.randomUUID();
		} else {
			randomId = this._generateRandomIdFallback();
		}

		return `${entityType}-${randomId}`;
	}

	private _generateRandomIdFallback(): string {
		const array = new Uint8Array(16);
		crypto.getRandomValues(array);

		const hex = Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
		const randomId = [
			hex.slice(0, 8),
			hex.slice(8, 12),
			'4' + hex.slice(13, 16),
			((parseInt(hex.slice(16, 17), 16) & 0x3) | 0x8).toString(16) + hex.slice(17, 20),
			hex.slice(20, 32)
		].join('-');
		return randomId;
	}

	public setInitialValues(entityType: EntityType): EntityTimestamps {
		const now = new Date();
		const id = this._generateUniqueId(entityType);

		return {
			id,
			created_at: now,
			updated_at: now
		};
	}

	public setId(entityType: EntityType): string {
		return this._generateUniqueId(entityType);
	}

	public setCreatedAt(date?: Date): Date {
		return date || new Date();
	}

	public setUpdatedAt(date?: Date): Date {
		return date || new Date();
	}

	public updateTimestamp<T extends EntityTimestamps>(entity: T): T {
		return {
			...entity,
			updated_at: new Date()
		};
	}
}

export const idTimestampManager = new IDTimestampManager();